import { NavigationItemType } from 'core/slices/models';
import { ReportSelectOptionType } from 'types/reports';

/**
 * Helper function to flatten the hierarchical data into a list of reports
 * @param node tha navigation data
 * @param reports , used in recursion
 */
export const flattenReports = (
  node,
  reports: ReportSelectOptionType[] = []
) => {
  if (node) {
    if (node.nodeType === NavigationItemType.REPORT) {
      if (node.id) {
        reports.push({
          value: node.id,
          label: node.name ? node.name : node.id,
          reportData: node,
        });
      }
    }
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => flattenReports(child, reports));
    }
  }
  return reports;
};
